Theme.ComponentCollections.Videos = (function () {
  const collection = new Theme.ComponentCollection("component-video");

  function pause() {
    collection.elements.forEach(video => video.pause());
  }

  return {
    pause
  }
})();

class ComponentVideo extends Theme.Component {
  constructor() {
    super();
  }

  connectedCallback() {
    this.defineElementCollections({
      videos: "video"
    });

    this.defineElements({
      button: "button"
    });

    this.collection = Theme.ComponentCollections.Videos;

    if (this.data.autoplay) {
      this.togglePlaybackIfHidden();
      return;
    }

    this.pauseOutsideViewport();
    this.pauseOnViewportResize();
    this.events();
  }

  play() {
    this.collection.pause();

    this.elements.videos.forEach(video => {
      if (this.isVisible(video)) {
        video.play();
      }
    });

    this.setAttribute("playing", true);
  }

  pause() {
    if (this.data.autoplay) {
      return;
    }

    this.elements.videos.forEach(video => {
      video.pause();
    });

    this.removeAttribute("playing");
  }

  pauseOutsideViewport() {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          this.pause();
        }
      });
    });

    observer.observe(this);
  }

  pauseOnViewportResize() {
    window.addEventListener("resize", Theme.Helpers.debounce(() => {
      this.pause();
    }, 150));
  }

  togglePlaybackIfHidden() {
    const toggle = () => {
      this.elements.videos.forEach(video => {
        if (this.isVisible(video)) {
          video.play();
        } else {
          video.pause();
        }
      });
    }

    toggle();

    window.addEventListener("resize", Theme.Helpers.debounce(toggle, 150));
  }

  isVisible(video) {
    return video.offsetParent !== null;
  }
}

customElements.define("component-video", ComponentVideo);
